import { ChangeDetectionStrategy, Component, computed, input, output } from "@angular/core";

/**
 * Barra fixa de personificação (DEV-742, Figma 145525-49). Componente
 * presentational: recebe os dados prontos e emite `exit` ao clicar em "Voltar".
 */
@Component({
  selector: "lkt-impersonation-bar",
  standalone: true,
  templateUrl: "./impersonation-bar.component.html",
  styleUrl: "./impersonation-bar.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LktImpersonationBarComponent {
  public readonly impersonatedName = input<string>("");
  public readonly profileLabel = input<string>("");
  public readonly context = input<string>("");
  public readonly adminName = input<string>("");
  public readonly testId = input<string>("impersonation-bar");

  public readonly exit = output<void>();

  public readonly exitTestId = computed<string>(() => `${this.testId()}-exit-button`);

  public onExit(): void {
    this.exit.emit();
  }
}
